<div
  (click)="isMobile ? gotoDetails(card) : null"
  [style.background]="
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 36.65%, #000000 110.56%),url(' +
      card?.image?.image?.url || '/assets/images/events/default-img.svg' + ')'
  "
  class="card-container"
>
  <p class="name">
    {{ helpers.getElementTranslatedName(card) }}
  </p>
  <div class="onhover details">
    <p class="name-onhover mb-1">
      {{ helpers.getElementTranslatedName(card) }}
    </p>
    <p class="desc">{{ helpers.getElementTranslatedDescRest(card) }}</p>
    <button (click)="gotoDetails(card)" class="btn btn-more">
      {{ "learn-more" | translate }}
    </button>
  </div>
</div>
